export const ADD_CART = "ADD_CART";
export const REMOVE_CART = "REMOVE_CART";
export const SELECT_CART = "SELECT_CART";
export const UPDATE_CART_ITEM = "UPDATE_CART_ITEM";
export const CHANGE_CART_NAME = "UPDATE_CART_NAME";
export const ADD_ITEM_TO_CART = "ADD_ITEM_TO_CART";
export const REMOVE_ITEM_FROM_CART = "REMOVE_ITEM_FROM_CART";
export const GET_CARTS = "GET_CARTS";
export const COPY_CART = "COPY_CART";
export const CHANGE_FLOAT_CART_STATE = "CHANGE_FLOAT_CART_STATE";
export const MANAGE_FAVORITES = "MANAGE_FAVORITES";
export const FILTER = "FILTER";
export const SORT = "SORT";
export const ADD_SORT_TAG = "ADD_SORT_TAG";
export const RESET_SORT = "RESET_SORT";